import React from "react";
import { Box, Chip, Button, Stack, Typography } from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";

const AppliedFilters = ({ filterData, setFilterData, onFilterChange }) => {
  // Build list of active filters (skip null or "all")
  const activeFilters = Object.entries(filterData).filter(([, value]) => {
    if (!value) return false;
    if (typeof value === "string" && value === "all") return false;
    if (typeof value === "object" && Object.keys(value).length === 0)
      return false;
    return true;
  });

  if (!activeFilters.length) return null;

  // Remove single filter
  const handleRemove = (key) => {
    const updated = { ...filterData, [key]: "all" };
    setFilterData(updated);
    onFilterChange?.(updated);
  };

  // Clear all filters
  const handleClearAll = () => {
    const cleared = Object.fromEntries(
      Object.keys(filterData).map((key) => [key, "all"])
    );
    setFilterData(cleared);
    onFilterChange?.(cleared);
  };

  // Helper to get display label
  const getDisplayValue = (val) => {
    if (typeof val === "object" && val !== null) {
      return val.name || val.title ||val.label || "N/A";
    }
    return val;
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        alignItems="start"
        useFlexGap
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Applied Filters:
        </Typography>

        {activeFilters.map(([key, value]) => (
          <Chip
            key={key}
            label={`${
              key.charAt(0).toUpperCase() + key.slice(1)
            }: ${getDisplayValue(value)}`}
            onDelete={() => handleRemove(key)}
            color="primary"
            variant="outlined"
            sx={{
              fontSize: "0.875rem",
              borderRadius: "8px",
              textTransform: "capitalize",
            }}
          />
        ))}

        <Button
          size="small"
          startIcon={<ClearAllIcon />}
          onClick={handleClearAll}
          sx={{
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          Clear All
        </Button>
      </Stack>
    </Box>
  );
};

export default AppliedFilters;
